import { TaxonomyManager } from "./Taxonomy";

export default function Categories() {
  return (
    <TaxonomyManager
      kind="categories"
      title="Gerenciar Categorias"
      subtitle="Crie, renomeie, ordene e ative as categorias da loja. Os filtros do catálogo e o formulário de produtos são atualizados automaticamente."
      placeholder="Nova categoria — ex.: Snacks, Molhos, Creatinas"
      helpText='Excluir só é permitido quando nenhum produto usa a categoria — assim nenhum produto fica sem categoria. Categorias inativas somem dos filtros da loja, mas os produtos continuam visíveis em "Todos".'
      testidPrefix="cat"
      noun="Categoria"
    />
  );
}
